import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { projectInfoTabs } from '../../helpers/constants';
import ProjectAboutTheProject from './ProjectAboutTheProject';
import ProjectMediaReleases from './ProjectMediaReleases';
import ProjectSaleInfo from './ProjectSaleInfo';
import ProjectTokenInfo from './ProjectTokenInfo';
import ProjectYourAllocations from './ProjectYourAllocations';
import './MercurXProjectInfo.scss';

function MercurXProjectInfo({ ...props }) {
  const { project, history } = props;
  const [activeTab, setActiveTab] = useState(projectInfoTabs.PROJECT_INFO_SALE_INFO);

  return (
    <>
      <Row className="mx-0">
        {[{
          key: projectInfoTabs.PROJECT_INFO_SALE_INFO,
          label: 'Sale Info',
          Component: ProjectSaleInfo,
        }, {
          key: projectInfoTabs.PROJECT_INFO_TOKEN_INFO,
          label: 'Token Info',
          Component: ProjectTokenInfo,
        }, {
          key: projectInfoTabs.PROJECT_INFO_ABOUT_THE_PROJECT,
          label: 'About Project',
          Component: ProjectAboutTheProject,
        }, {
          key: projectInfoTabs.PROJECT_INFO_YOUR_ALLOCATIONS,
          label: 'Your Allocations',
          Component: ProjectYourAllocations,
        }, {
          key: projectInfoTabs.PROJECT_INFO_YOUR_MEDIA_RELEASES,
          label: 'Media Releases',
          Component: ProjectMediaReleases,
        }].map(({ key, label, Component }) => (
          <Col key={key} sm={6} md={4} lg={true} className="px-1 mt-2">
            <div
              className={
                'project-info-tab text-fs-head-xxs py-3 text-center ' +
                (activeTab === key ? 'project-info-tab-active' : '')
              }
              onClick={() => setActiveTab(key)}
            >
              {label}
            </div>
            {activeTab === key && (
              <div className="project-info-content-container border p-3 d-sm-none d-block">
                <Component {...props} />
              </div>
            )}
          </Col>
        ))}
      </Row>
      <div className="project-info-content-container border p-3 d-none d-sm-block">
        {activeTab === projectInfoTabs.PROJECT_INFO_SALE_INFO && (
          <ProjectSaleInfo className="d-none d-sm-block" {...props} />
        )}
        {activeTab === projectInfoTabs.PROJECT_INFO_TOKEN_INFO && (
          <ProjectTokenInfo className="d-none d-sm-block" {...props} />
        )}
        {activeTab === projectInfoTabs.PROJECT_INFO_ABOUT_THE_PROJECT && (
          <ProjectAboutTheProject className="d-none d-sm-block" {...props} />
        )}
        {activeTab === projectInfoTabs.PROJECT_INFO_YOUR_ALLOCATIONS && (
          <ProjectYourAllocations className="d-none d-sm-block" {...props} />
        )}
        {activeTab === projectInfoTabs.PROJECT_INFO_YOUR_MEDIA_RELEASES && (
          <ProjectMediaReleases className="d-none d-sm-block" {...props} />
        )}
      </div>
    </>
  );
}

export default MercurXProjectInfo;
